/**
 * @generated SignedSource<<25d67e3a10cf753d8ebced3d042dbc9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternBrandBuildsQuery$variables = {
  brandId: string;
};
export type InternBrandBuildsQuery$data = {
  readonly appBuildPipelines: ReadonlyArray<{
    readonly appBuildNumber: string;
    readonly appVersion: string;
    readonly circleciPipelineId: string;
    readonly completedAt: any | null;
    readonly id: string;
    readonly includeReleaseNotes: boolean;
    readonly isAutomatic: boolean;
    readonly platform: string;
    readonly startedAt: any;
    readonly status: string;
    readonly submitOutcome: string;
    readonly submitOutcomeDetail: string;
    readonly triggerReason: any;
  }>;
  readonly appStoreReviews: ReadonlyArray<{
    readonly appVersion: string;
    readonly buildNumber: string;
    readonly id: string;
    readonly platform: string;
    readonly rejectionReason: string;
    readonly reviewedAt: any | null;
    readonly status: string;
    readonly statusDisplay: string;
    readonly submittedAt: any | null;
  }>;
  readonly latestAndroidReview: {
    readonly appVersion: string;
    readonly buildNumber: string;
    readonly id: string;
    readonly platform: string;
    readonly rejectionReason: string;
    readonly reviewedAt: any | null;
    readonly status: string;
    readonly statusDisplay: string;
    readonly submittedAt: any | null;
  } | null;
  readonly latestIosReview: {
    readonly appVersion: string;
    readonly buildNumber: string;
    readonly id: string;
    readonly platform: string;
    readonly rejectionReason: string;
    readonly reviewedAt: any | null;
    readonly status: string;
    readonly statusDisplay: string;
    readonly submittedAt: any | null;
  } | null;
  readonly pendingAndroidScheduledBuild: {
    readonly changesCount: number;
    readonly id: string;
    readonly lastChangeAt: any;
    readonly pendingChanges: any;
    readonly platform: string;
    readonly scheduledFor: any;
    readonly status: string;
  } | null;
  readonly pendingIosScheduledBuild: {
    readonly changesCount: number;
    readonly id: string;
    readonly lastChangeAt: any;
    readonly pendingChanges: any;
    readonly platform: string;
    readonly scheduledFor: any;
    readonly status: string;
  } | null;
  readonly resolvedReleaseNotes: {
    readonly includeReleaseNotes: boolean;
    readonly notes: ReadonlyArray<{
      readonly isOverride: boolean;
      readonly locale: string;
      readonly text: string;
    }>;
  };
  readonly scheduledBuilds: ReadonlyArray<{
    readonly changesCount: number;
    readonly firstChangeAt: any;
    readonly id: string;
    readonly lastChangeAt: any;
    readonly pendingChanges: any;
    readonly pipelineId: string | null;
    readonly platform: string;
    readonly scheduledFor: any;
    readonly status: string;
  }>;
};
export type InternBrandBuildsQuery = {
  response: InternBrandBuildsQuery$data;
  variables: InternBrandBuildsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "brandId",
  "variableName": "brandId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "platform",
    "value": "ios"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platform",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "changesCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledFor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastChangeAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingChanges",
  "storageKey": null
},
v10 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "platform",
    "value": "android"
  }
],
v12 = [
  (v1/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appVersion",
  "storageKey": null
},
v14 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "buildNumber",
    "storageKey": null
  },
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statusDisplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "submittedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reviewedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rejectionReason",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeReleaseNotes",
  "storageKey": null
},
v16 = [
  {
    "alias": "pendingIosScheduledBuild",
    "args": (v2/*: any*/),
    "concreteType": "ScheduledBuildType",
    "kind": "LinkedField",
    "name": "pendingScheduledBuild",
    "plural": false,
    "selections": (v10/*: any*/),
    "storageKey": null
  },
  {
    "alias": "pendingAndroidScheduledBuild",
    "args": (v11/*: any*/),
    "concreteType": "ScheduledBuildType",
    "kind": "LinkedField",
    "name": "pendingScheduledBuild",
    "plural": false,
    "selections": (v10/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v12/*: any*/),
    "concreteType": "ScheduledBuildType",
    "kind": "LinkedField",
    "name": "scheduledBuilds",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstChangeAt",
        "storageKey": null
      },
      (v8/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pipelineId",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": "latestIosReview",
    "args": (v2/*: any*/),
    "concreteType": "AppStoreReviewStatusType",
    "kind": "LinkedField",
    "name": "latestAppStoreReview",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  {
    "alias": "latestAndroidReview",
    "args": (v11/*: any*/),
    "concreteType": "AppStoreReviewStatusType",
    "kind": "LinkedField",
    "name": "latestAppStoreReview",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "limit",
        "value": 10
      }
    ],
    "concreteType": "AppStoreReviewStatusType",
    "kind": "LinkedField",
    "name": "appStoreReviews",
    "plural": true,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "limit",
        "value": 15
      }
    ],
    "concreteType": "AppBuildPipelineType",
    "kind": "LinkedField",
    "name": "appBuildPipelines",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAutomatic",
        "storageKey": null
      },
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appBuildNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "circleciPipelineId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "submitOutcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "submitOutcomeDetail",
        "storageKey": null
      },
      (v15/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "triggerReason",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v12/*: any*/),
    "concreteType": "ResolvedReleaseNotesPreview",
    "kind": "LinkedField",
    "name": "resolvedReleaseNotes",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ReleaseNotePreviewEntry",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOverride",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandBuildsQuery",
    "selections": (v16/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandBuildsQuery",
    "selections": (v16/*: any*/)
  },
  "params": {
    "cacheID": "5129813e8daab29921094e94508c9a67",
    "id": null,
    "metadata": {},
    "name": "InternBrandBuildsQuery",
    "operationKind": "query",
    "text": "query InternBrandBuildsQuery(\n  $brandId: ID!\n) {\n  pendingIosScheduledBuild: pendingScheduledBuild(brandId: $brandId, platform: \"ios\") {\n    id\n    platform\n    changesCount\n    scheduledFor\n    lastChangeAt\n    status\n    pendingChanges\n  }\n  pendingAndroidScheduledBuild: pendingScheduledBuild(brandId: $brandId, platform: \"android\") {\n    id\n    platform\n    changesCount\n    scheduledFor\n    lastChangeAt\n    status\n    pendingChanges\n  }\n  scheduledBuilds(brandId: $brandId) {\n    id\n    platform\n    changesCount\n    scheduledFor\n    lastChangeAt\n    firstChangeAt\n    status\n    pendingChanges\n    pipelineId\n  }\n  latestIosReview: latestAppStoreReview(brandId: $brandId, platform: \"ios\") {\n    id\n    platform\n    appVersion\n    buildNumber\n    status\n    statusDisplay\n    submittedAt\n    reviewedAt\n    rejectionReason\n  }\n  latestAndroidReview: latestAppStoreReview(brandId: $brandId, platform: \"android\") {\n    id\n    platform\n    appVersion\n    buildNumber\n    status\n    statusDisplay\n    submittedAt\n    reviewedAt\n    rejectionReason\n  }\n  appStoreReviews(brandId: $brandId, limit: 10) {\n    id\n    platform\n    appVersion\n    buildNumber\n    status\n    statusDisplay\n    submittedAt\n    reviewedAt\n    rejectionReason\n  }\n  appBuildPipelines(brandId: $brandId, limit: 15) {\n    id\n    platform\n    status\n    isAutomatic\n    appVersion\n    appBuildNumber\n    startedAt\n    completedAt\n    circleciPipelineId\n    submitOutcome\n    submitOutcomeDetail\n    includeReleaseNotes\n    triggerReason\n  }\n  resolvedReleaseNotes(brandId: $brandId) {\n    includeReleaseNotes\n    notes {\n      locale\n      text\n      isOverride\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a03a0bc7c8500cac358e14fa9ac179f1";

export default node;
